module.exports = __webpack_public_path__ + "static/media/access-control.bffb6546.svg";